// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function fetchHealthQuestionnaires({ options }) {
  return { type: types.HEALTH_FETCH_BEGIN, options }
}
